// src/contexts/LanguageContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations, getTranslation } from '../locales';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // LocalStorage'dan dil tercihini oku, yoksa 'en' kullan
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('turf-manager-language');
    return saved || 'en';
  });

  // Dil değiştiğinde localStorage'a kaydet
  useEffect(() => {
    localStorage.setItem('turf-manager-language', language);
  }, [language]);

  const t = (key, params = {}) => {
    const value = getTranslation(language, key);

    if (typeof value === 'function') {
      return value(params);
    }

    if (typeof value === 'string' && Object.keys(params).length > 0) {
      return Object.entries(params).reduce((result, [paramKey, paramValue]) => {
        return result.replace(new RegExp(`{${paramKey}}`, 'g'), paramValue);
      }, value);
    }

    return value;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
